/**
 * Global notice selector for RedeProto.
 *
 * Rendered at the top of the tab (between the SubNav and the content). Changing
 * the notice updates the layout state, and every screen re-runs its scoped
 * fetches. "All notices" (empty value) restores the consolidated view
 * (`selectedNoticeId = null`).
 */
import { MenuItem } from '@mui/material';

import { RedeProtoOutletContext } from '../../types';
import { Label, Select, Wrapper } from './styles';

const ALL_NOTICES = 'all';

export function NoticeSelector({
  selectedNoticeId,
  setSelectedNoticeId,
  noticeOptions,
}: RedeProtoOutletContext): JSX.Element {
  const value =
    selectedNoticeId == null ? ALL_NOTICES : String(selectedNoticeId);

  const handleChange = (next: string): void => {
    setSelectedNoticeId(next === ALL_NOTICES ? null : Number(next));
  };

  return (
    <Wrapper>
      <Label>Edital</Label>
      <Select
        select
        size="small"
        value={value}
        onChange={(event) => handleChange(event.target.value)}
      >
        <MenuItem value={ALL_NOTICES}>Todos os editais</MenuItem>
        {noticeOptions.map((notice) => (
          <MenuItem key={notice.id} value={String(notice.id)}>
            {notice.name}
          </MenuItem>
        ))}
      </Select>
    </Wrapper>
  );
}
